export enum MimeType {
    ApplicationIllustrator = 'application/illustrator',
    ApplicationMsWord = 'application/msword',
    ApplicationOctetStream = 'application/octet-stream',
    ApplicationPdf = 'application/pdf',
    ApplicationPostscript = 'application/postscript',
    ApplicationVndMsExcel = 'application/vnd.ms-excel',
    ApplicationVndMsPowerpoint = 'application/vnd.ms-powerpoint',
    ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ApplicationZip = 'application/zip',
    AudioMp3 = 'audio/mp3',
    AudioMpeg3 = 'audio/mpeg3',
    AudioWav = 'audio/wav',
    ImageGif = 'image/gif',
    ImageJpeg = 'image/jpeg',
    ImagePng = 'image/png',
    ImageVndAdobePhotoshop = 'image/vnd.adobe.photoshop',
    TextCsv = 'text/csv',
    TextHtml = 'text/html',
    TextPlain = 'text/plain',
    Unknown = 'unknown',
    VideoAvi = 'video/avi',
    VideoMp4 = 'video/mp4',
    VideoQuicktime = 'video/quicktime',
    VideoWma = 'video/wma',
    VideoWmv = 'video/wmv',
}
